import React from 'react';

import { Link } from 'react-router-dom';

import FooterMenu from '@app/components/UI/Footer/FooterMenu';
import { ScreenWidth, useIsMobile } from '@app/hooks/useIsMobile';
import IconTikTok from '@app/images/social/IconTikTok';
import IconTwitter from '@app/images/social/IconTwitter';
import iconFacebook from '@app/images/social/icon_facebook.svg';
import iconInstagram from '@app/images/social/icon_instagram.svg';
import iconLinkedin from '@app/images/social/icon_linkedin.svg';
import iconYoutube from '@app/images/social/icon_youtube.svg';

const year = new Date().getFullYear();

const Footer: React.FC = () => {
	const isMobile = useIsMobile(ScreenWidth.widthXS);

	return (
		<footer className="site-footer">
			<div className="site-footer-wrapper">
				<div className="site-footer-body">
					<img className="site-footer-body__logo" src={require('@app/images/logo_glyph_light.svg')} alt="Logo" />
					<FooterMenu />
					<div className="site-footer-contacts">
						<h4 className="site-footer-contacts__title">
							{isMobile ? (
								<a
									className="site-footer-contacts__link"
									href="https://info.lapoflove.com/senior-pet-digest"
									target="_blank"
									rel="noopener noreferrer"
								>
									Subscribe
								</a>
							) : (
								'Subscribe'
							)}
							{' '}
							to the Senior Pet Digest
						</h4>
						{!isMobile && (
							<p className="site-footer-contacts__text">
								<a
									className="site-footer-contacts__link"
									href="https://info.lapoflove.com/senior-pet-digest"
									target="_blank"
									rel="noopener noreferrer"
								>
									Subscribe here
								</a>
								&nbsp; to view our monthly newsletter with helpful pet articles, insights, and resources.
							</p>
						)}
						<FooterMenu isMobile />
						<div className="site-footer-contacts-connect">
							<img className="site-footer-contacts-connect__logo" src={require('@app/images/logo_glyph_light.svg')} alt="Logo" />
							<div className="social-block">
								<b>Connect with us:</b>
								<div className="social-block-list">
									<a href="https://www.facebook.com/lapoflove" target="_blank" rel="noopener noreferrer">
										<img className="social-link" src={iconFacebook} alt="Facebook" />
									</a>
									<a href="https://x.com/LapofLoveVets" target="_blank" rel="noopener noreferrer" className="twitter">
										<IconTwitter />
									</a>
									<a href="https://www.instagram.com/lapofloveveterinaryhospice/" target="_blank" rel="noopener noreferrer">
										<img className="social-link" src={iconInstagram} alt="Instagram" />
									</a>
									<a href="https://www.youtube.com/user/Lapoflove" target="_blank" rel="noopener noreferrer">
										<img className="social-link" src={iconYoutube} alt="Youtube" />
									</a>
									<a
										href="https://www.linkedin.com/company/lap-of-love-veterinary-hospice"
										target="_blank"
										rel="noopener noreferrer"
									>
										<img className="social-link" src={iconLinkedin} alt="Linkedin" />
									</a>
									<a href="https://www.tiktok.com/@lapoflovevets" target="_blank" rel="noopener noreferrer">
										<div className="social-link tiktok">
											<IconTikTok />
										</div>
									</a>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="site-footer-bottom">
					<span className="site-footer-bottom__copyright">
						{`© 2010-${year} Lap of Love. All rights reserved.`}
					</span>
					<div className="site-footer-bottom__policies">
						<Link to="/policies/privacy-policy">Privacy Policy</Link>
						<Link to="/policies/terms-and-conditions">Terms and Conditions</Link>
						<Link to="/policies/accessibility-policy">Accessibility Policy</Link>
					</div>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
